import { SafeResourceUrl } from '@angular/platform-browser';

import { AiMedicalDocumentItem, MedicalDocumentItem, UploadingMedicalDocumentItem } from './document.interface';

export interface MedicalDocumentsState {
  isAiMedicalDataEnabled: boolean;
  isAiSearchFeatureEnabled: boolean;
  isAiSearchChecked: boolean;
  aiSearchResponseMessage: string;
  isAiSearchLoading: boolean;
  documentsSearchTerm: string;
  documentsPageConfig: PageConfig;
  documents: MedicalDocumentItem[];
  aiDocuments: AiMedicalDocumentItem[];
  uploadingDocuments: UploadingMedicalDocumentItem[];
  currentDocument: MedicalDocumentItem | null;
  currentAiDocument: AiMedicalDocumentItem | null;
  currentDocumentPreview: SafeResourceUrl | null;
  isDocumentsListLoading: boolean;
  isCurrentDocumentLoading: boolean;
  isCurrentDocumentPreviewLoading: boolean;
  documentsError: string | null;
  detailsState: DocumentDetailsState;
  documentProcessingErrors: { [documentId: string]: string[] };
}

export interface PageConfig {
  page: number;
  pageSize: number;
  totalCount: number;
  hasNextPage: boolean;
  hasPreviousPage: boolean;
}

export enum DocumentDetailsState {
  Closed = 'closed',
  Opened = 'opened',
  InEdit = 'inEdit',
}
